import { render, staticRenderFns } from "./AreaSelect.vue?vue&type=template&id=126d1734&scoped=true&"
import script from "./AreaSelect.vue?vue&type=script&lang=js&"
export * from "./AreaSelect.vue?vue&type=script&lang=js&"
import style0 from "./AreaSelect.vue?vue&type=style&index=0&id=126d1734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d1734",
  null
  
)

export default component.exports